export default __webpack_public_path__ + "static/media/policeAtCar.9252993b.jpg";